import { FormLens } from "@tdp/common/form";

import { IUseFormFieldOptions, useFormFieldProps } from "./useFormFieldProps";

/**
 * Combines a hook for input props with a hook for form field props for the same lens' object.
 * 
 * Useful for creating hooks that provide both input and form field props for a given property.
 * @param useInputProps the hook for getting an input type's props for the specified lens (E.G. onChange & value for an Input component)
 * @returns a hook for { inputProps, fieldProps } to be injected into an input component and the associated Field component.
 */
export function createFormFieldPropHook<TLensType, THookOptions, TInputProps>(
  useInputProps: ((lens: FormLens<TLensType>, options?: THookOptions) => TInputProps)) {
  return function useFormInputProps(lens: FormLens<TLensType>, options: IUseFormFieldOptions & THookOptions) {
    const inputProps = useInputProps(lens, options);
    const fieldProps = useFormFieldProps(lens, options);
    return { inputProps, fieldProps };
  }
}
